import {
  faBasketShopping,
  faHeart,
  faSortDown,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Product_Info_Card_3.css";
import React, { useContext, useState } from "react";
import { Button } from "react-bootstrap";

import { useNavigate } from "react-router-dom";
import Blue_Btn from "../common_btn/blue_btn/Blue_Btn";
import Red_Outline_Btn from "../common_btn/red_outline_btn/Red_Outline_Btn";
import Dark_Blue_Btn from "../common_btn/dark_blue_btn/Dark_Blue_Btn";
import { Context } from "../../../utils/context";
import { encodeId } from "../../../utils/common";
import { addWishlist } from "../../../utils/apis/Wishlist/Wishlist";
import Login_Modal from "../../Common_modal/login_modal/Login_Modal";

const Product_Info_Card_3 = ({ product, showQty, product_id }) => {
  const [favouriteProduct, setFavouriteProduct] = useState();

  const navigate = useNavigate();

  const [addcartmodal, Setaddcartmodal] = useState(false);
  const [showIncrement, setShowIncrement] = useState(false);
  const {
    IMG_URL,
    shimmerLoader,
    setShimmerLoader,
    signin,
    wishlistContext,
    wishlistData,
  } = useContext(Context);

  const handleHeartClick = async (data) => {
    // setShimmerLoader(true);
    if (signin) {
      const res = await addWishlist(data);
      if (res?.success) {
        wishlistContext();
      }
      setShimmerLoader(false);
    } else {
      setShimmerLoader(false);
      setModalLShow(true);
      // setCount((count) => count + 1);
      // navigate("/login");
    }
  };

  const [modalLShow, setModalLShow] = useState(false);
  const [count, setCount] = useState(0);

  return (
    <section className="Product_Info_Card_3_Section">
      <div className="Product_Info_Card_3">
        <div
          className="upper_image_section"
          onClick={() => navigate(`/vendor-page/${encodeId(product?.id)}`)}
        >
          <div className="card_img_holder">
            <img
              className=""
              src={IMG_URL + product?.image1}
              alt={product?.product?.image1}
            />
          </div>
        </div>

        <div className="lower_text_section">
          <p
            className="product_name"
            onClick={() => navigate(`/vendor-page/${encodeId(product?.id)}`)}
          >
            {product?.name}
          </p>
          <p className="kg_text">
            {product?.product_variants?.length > 0
              ? product.product_variants[0].v_name
              : ""}
          </p>

          <div className="pricing_div">
            <div className="left_side">
              <p className="selling_price">
                ₹{product?.product_variants?.length > 0
                  ? product.product_variants[0].s_price
                  : ""}
              </p>
            </div>
          </div>

          <div className="text-center btn_holder">
            <div className="">
              <Dark_Blue_Btn
                btn_name="Add"
                onClick={() =>
                  navigate(`/vendor-page/${encodeId(product?.id)}`)
                }
              />
            </div>
          </div>

          <div
            className="favourite_div"
            onClick={(e) => {
              e.stopPropagation();
              handleHeartClick({
                product_id: product?.id,
                // variant_id: variant_id,
              });
            }}
          >
            <FontAwesomeIcon
              icon={faHeart}
              // className={`heart_icon ${
              //   prodname == favouriteProduct ? "deactive" : ""
              // }`}

              className={
                wishlistData?.some(
                  (item) => item.product_id === product_id,
                  // item.variant_id === variant_id
                )
                  ? "heart_icon active"
                  : "heart_icon "
              }
            />
            {/* <FontAwesomeIcon
              icon={faHeart}
              className={`heart_icon ${
                product?.id == favouriteProduct ? "active" : ""
              }`}
            /> */}
          </div>
        </div>
      </div>

      <Login_Modal
        key={count}
        show={modalLShow}
        onHide={() => setModalLShow(false)}
      />
    </section>
  );
};

export default Product_Info_Card_3;
